/**
 * Card primitives — white surface container + composed header/body.
 *
 * Usage:
 *   <Card>
 *     <CardHeader title="Traffic Sources" subtitle="Last 28 days" right={<Badge>Live</Badge>} />
 *     <CardBody>…</CardBody>
 *   </Card>
 */

export function Card({ children, className = "" }) {
  return (
    <div
      className={`bg-surface border border-border-default rounded-card ${className}`}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, right }) {
  return (
    <div className="flex items-start justify-between gap-4 px-5 py-4 border-b border-border-light">
      <div className="min-w-0">
        <div className="text-[13px] font-semibold text-text-primary leading-tight">
          {title}
        </div>
        {subtitle && (
          <div className="text-[11px] text-text-muted mt-0.5 leading-snug">
            {subtitle}
          </div>
        )}
      </div>
      {right && <div className="flex-shrink-0">{right}</div>}
    </div>
  );
}

export function CardBody({ children, className = "" }) {
  return <div className={`px-5 py-4 ${className}`}>{children}</div>;
}
